// "content-accordion"
$(".content-accordion-header .content-accordion-toggle").click(function() {
  $(this).toggleClass("active");

  var accordion_content = $(this).parent().next(".content-accordion-data");
  accordion_content.toggleClass("active");

  if( accordion_content.hasClass('active') ) {
    $(this).attr('aria-expanded', true);
    accordion_content.attr('aria-hidden', false);
  } else {
    $(this).attr('aria-expanded', false);
    accordion_content.attr('aria-hidden', true);
  }
});


var AccordionGroup = {

  elements: {
    'container': '.panel-group.ceremonies-nav',
    'collapseTarget': '.panel-group.ceremonies-nav .panel-collapse',
    'toggleButton': '.panel-group.ceremonies-nav .accordion-toggle'
  },
  debug: false,

  init: function() {

    if(this.debug)
      console.log('Initializing AccordionGroup');

    if( $(this.elements.container).length > 0 ) {

      const firstAccordionElement = $(this.elements.container + ':first');

      firstAccordionElement.removeClass('closed');
      firstAccordionElement.addClass('open');
      firstAccordionElement.find('.accordion-toggle').attr('aria-expanded', true);
      firstAccordionElement.find('.panel-collapse').attr('aria-hidden', false);

      this.setBindings();

      if(this.debug)
        console.log('AccordionGroup initialized');
    }
  },

  setBindings: function() {
    $(this.elements.toggleButton).on('click', this.toggleElement.bind(this));
  },

  toggleElement: function(e) {

    let clickedActiveElement = false;
    const clickedElem = $(e.target);
    const clickedElemAccordion = clickedElem.closest(this.elements.container);

    if( clickedElemAccordion.hasClass('open') )
      clickedActiveElement = true;

    $(this.elements.container).removeClass('open');
    $(this.elements.container).addClass('closed');
    $(this.elements.toggleButton).attr('aria-expanded', false);
    $(this.elements.collapseTarget).attr('aria-hidden', true);

    if(!clickedActiveElement) {
      clickedElemAccordion.addClass('open');
      clickedElemAccordion.removeClass('closed');
      clickedElem.attr('aria-expanded', true);
      clickedElemAccordion.find('.panel-collapse').attr('aria-hidden', false);
    }
  }

};

AccordionGroup.init();
